import { atom, useAtom } from 'jotai';

export const selectedEnvTypeAtom = atom(undefined);

export function useSelectedEnvTypeAtom() {
    return useAtom(selectedEnvTypeAtom);
  }